"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.matchesTimeObject = exports.toLeadingZero12HrString = exports.toLeadingZero = exports.toNumber = exports.toArray = void 0;
var regex_1 = require("../regex/regex");
exports.toArray = function (arrayLikeThing) { return Array.prototype.slice.call(arrayLikeThing, 0); };
exports.toNumber = function (value) {
    var number = Number(value);
    return isNaN(number) ? null : number;
};
exports.toLeadingZero = function (value) {
    if (value === null || value === '-')
        return '--';
    var number = Number(value);
    if (isNaN(number) && typeof value !== 'number')
        return value;
    return number < 10 ? "0" + number : "" + number;
};
exports.toLeadingZero12HrString = function (value) {
    if (!value)
        return '--:-- --';
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var _a = regex_1.regex.lenientString12hr.exec(value) || [], _val = _a[0], hrs = _a[1], minutes = _a[2], mode = _a[3];
    return exports.toLeadingZero(hrs) + ":" + exports.toLeadingZero(minutes) + " " + exports.toLeadingZero(mode);
};
exports.matchesTimeObject = function (timeObjA, timeObjB) {
    return JSON.stringify(timeObjA) === JSON.stringify(timeObjB);
};
